/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompletedAt
 */
export interface CompletedAt {
}

/**
 * Check if a given object implements the CompletedAt interface.
 */
export function instanceOfCompletedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompletedAtFromJSON(json: any): CompletedAt {
    return CompletedAtFromJSONTyped(json, false);
}

export function CompletedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedAt {
    return json;
}

export function CompletedAtToJSON(value?: CompletedAt | null): any {
    return value;
}

